export const ID = 'SPECIALTIES';

export const LOAD_SPECIALTIES = `${ID}/LOAD_SPECIALTIES`;
export const LOAD_SPECIALTIES_COMPLETED = `${ID}/LOAD_SPECIALTIES_COMPLETED`;
export const LOAD_SPECIALTIES_FAILED = `${ID}/LOAD_SPECIALTIES_FAILED`;

export const LOAD_SUBSPECIALTIES = `${ID}/LOAD_SUBSPECIALTIES`;
export const LOAD_SUBSPECIALTIES_COMPLETED = `${ID}/LOAD_SUBSPECIALTIES_COMPLETED`;
export const LOAD_SUBSPECIALTIES_FAILED = `${ID}/LOAD_SUBSPECIALTIES_FAILED`;
